import { initializeApp } from 'firebase/app'; // Import Firebase initialization function
import { getFirestore, doc, setDoc, arrayUnion, arrayRemove } from 'firebase/firestore'; // Import Firestore functions for managing documents and arrays
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'; // Import Firebase Storage functions for file uploads and retrievals
import { 
  getAuth, 
  GoogleAuthProvider, 
  GithubAuthProvider, 
  FacebookAuthProvider, 
  updateProfile, 
  RecaptchaVerifier, 
  signInWithPopup, 
  signInWithPhoneNumber, 
  createUserWithEmailAndPassword, 
  PhoneAuthProvider, 
  signInWithCredential 
} from 'firebase/auth'; // Import various Firebase Authentication methods and providers

// Firebase configuration object containing keys and identifiers for the Firebase project
// const firebaseConfig = {
//   apiKey: "AIzaSyArX-oW_LVGm2-qY8FKRVFpvTY5b-IWUBg", // API key for accessing Firebase services
//   authDomain: "eventmgmtapp1.firebaseapp.com", // Auth domain for Firebase Authentication
//   projectId: "eventmgmtapp1", // Project ID
//   storageBucket: "eventmgmtapp1.appspot.com", // Storage bucket for file storage
//   messagingSenderId: "1068587830419", // Messaging sender ID for Firebase Cloud Messaging
//   appId: "1:1068587830419:web:daa56b59e327441b775166", // App ID for the project
//   measurementId: "G-P4YYMLTB33" // Measurement ID for analytics (if using Firebase Analytics)
// };

const firebaseConfig = {
  apiKey: "AIzaSyAKdUC7c7XY0ke1Zeo_3XIlV5vDD17NLv4",
  authDomain: "ovevent5.firebaseapp.com",
  projectId: "ovevent5",
  storageBucket: "ovevent5.appspot.com",
  messagingSenderId: "155363539471",
  appId: "1:155363539471:web:659c597b1e71b0ac25017a",
  measurementId: "G-7VSYY6PJ93"
};

// Initialize Firebase with the configuration object
const app = initializeApp(firebaseConfig); // Create and initialize a Firebase app instance
const auth = getAuth(app); // Initialize Firebase Authentication and get a reference to the auth object
const firestore = getFirestore(app); // Initialize Firestore and get a reference to the Firestore database
const storage = getStorage(app); // Initialize Firebase Storage and get a reference to the storage service

// Initialize authentication providers for different login methods
const googleProvider = new GoogleAuthProvider(); // Google authentication provider
const githubProvider = new GithubAuthProvider(); // GitHub authentication provider
const facebookProvider = new FacebookAuthProvider(); // Facebook authentication provider

// Exporting the Firebase services and authentication providers for use in other parts of the application
export {
  auth, // Export Firebase Authentication object
  googleProvider, // Export Google authentication provider
  githubProvider, // Export GitHub authentication provider
  facebookProvider, // Export Facebook authentication provider
  RecaptchaVerifier, // Export ReCaptcha Verifier for bot protection
  signInWithPopup, // Export sign-in method for popup-based authentication
  signInWithPhoneNumber, // Export sign-in method for phone number authentication
  createUserWithEmailAndPassword, // Export method for creating users with email and password
  PhoneAuthProvider, // Export PhoneAuthProvider for handling phone authentication
  signInWithCredential, // Export sign-in method for handling existing credentials
  updateProfile, // Export method for updating user profile information
  firestore, // Export Firestore database instance
  storage, // Export Firebase Storage instance
  storageRef, // Export Firebase Storage reference function for file management
  uploadBytes, // Export function for uploading files to Firebase Storage
  getDownloadURL, // Export function to get download URLs for files in Firebase Storage
  arrayUnion, // Export arrayUnion for adding elements to arrays in Firestore
  arrayRemove, // Export arrayRemove for removing elements from arrays in Firestore
  firebaseConfig // Export the Firebase configuration object
};
